import { render, staticRenderFns } from "./BandejaCambiarEstatusEnEsperaComponente.vue?vue&type=template&id=6a802363"
import script from "./BandejaCambiarEstatusEnEsperaComponente.vue?vue&type=script&lang=js"
export * from "./BandejaCambiarEstatusEnEsperaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports